import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import moment from 'moment'
import { Icon,Button,CellGroup,Cell,CheckboxGroup,Checkbox,Form,Field,RadioGroup,Radio,NumberKeyboard,DatetimePicker,Popup,Picker } from 'vant';

Vue.config.productionTip = false

Vue.use(Icon).use(Button).use(CellGroup).use(Cell).use(CheckboxGroup).use(Checkbox).use(Form).use(Field).use(RadioGroup).use(Radio).use(NumberKeyboard).use(DatetimePicker).use(Popup).use(Picker)

var locale = window.navigator.userLanguage || window.navigator.language;
moment.locale(locale);
Vue.prototype.$moment = moment;

console.log("version:20200320_v1")

moment.locale(); 
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
